import { Button, Menu, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useIntl } from 'react-intl';
import { signOutOfTipDirect } from '../../../../utils/signOut';
import messages from '../messages';

const useStyles = makeStyles({
  menuStyle: {
    marginTop: '40px'
  },
  email: {
    textTransform: 'none'
  }
});

export default function SettingsMenu(props) {
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();

  const handleOpenDropDown = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleSignOut = () => {
    setAnchorEl(null);
    signOutOfTipDirect();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        className={props.isUsingEmail ? classes.email : ''}
        aria-controls="simple-menu"
        aria-haspopup="true"
        data-testid="user-menu-button"
        onClick={handleOpenDropDown}>
        {props.children}
      </Button>
      <Menu
        className={classes.menuStyle}
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}>
        <MenuItem onClick={handleSignOut}>{intl.formatMessage(messages.signOut)}</MenuItem>
      </Menu>
    </>
  );
}
